<template>
  <div class>
    <div
      class="members-card white rounded-5 w-100 h-auto position-relative"
      :style="{
        'z-index': getTour.current_number == 3 ? '120' : '',
      }"
    >
      <!-- CARD LABEL -->
      <div
        class="members-card-label position-absolute w-100 brand_accent_bg rounded-top-5"
      ></div>
      <!-- TOP CARD -->
      <div
        class="member-top d-flex justify-content-between align-items-center nowrap pointer"
        @click="toggleSwitchClass"
      >
        <div
          class="left d-flex justify-content-start align-items-start"
          title="Switch Classes"
        >
          <!-- CLASS SWITCH ICON -->
          <div class="avatar brand_inverse_light_bg">
            <span class="icon-swap brand_primary"></span>
          </div>

          <!-- CLASS NAME -->
          <div class="class-info">
            <div class="title font-weight-bold color_text">
              {{ class_name }}
            </div>
            <div class="text color_grey_dark">SwitchClass</div>
          </div>
        </div>

        <div class="right">
          <span
            class="d-block caret-icon icon-caret-down color_grey_dark font-10 pointer"
          ></span>
        </div>
      </div>

      <!-- BOTTOM CARD -->
      <div class="member-bottom d-none d-md-block">
        <div
          class="text color_grey_dark font-weight-bold text-uppercase font-12"
        >
          Assigned Teachers
        </div>

        <!-- TEACHER CONTENT GOES HERE -->
        <slot name="teacher__content"></slot>

        <!-- CODE INFO -->
        <div class="code-info color_grey_dark font-12">
          Share this code with anyone you wish to add to the class
        </div>
        <!-- CLASS CODE -->
        <div
          class="class-code color_white_bg color_grey_dark w-100 d-flex justify-content-start align-items-center position-relative"
        >
          <div>Class Code:</div>
          <div class="code font-weight-bold brand_navy">{{ class_code }}</div>

          <div
            class="copy-code brand_accent_light_bg font-12 brand_navy font-weight-bold pointer rounded-5"
            @click="copyClassCode"
          >
            <input
              type="text"
              ref="classCode"
              :value="class_code"
              class="position-absolute index--9"
              style="opacity: 0"
            />
            <div class="d-flex flex-center index-9">
              <span class="icon-copy mr-2"></span> COPY CLASS CODE
            </div>
          </div>
        </div>

        <!-- ADD NEW ITEM -->
        <div v-if="show_add_button">
          <router-link
            :to="{ name: button_route }"
            class="add-new"
            v-if="button_type === 'route'"
          >
            <div class="avatar avatar_sm_md brand_accent_bg pointer">
              <span class="flex-center icon-plus color_text font-24"></span>
            </div>
          </router-link>

          <router-link
            to
            class="add-new"
            @click="$emit(button_function)"
            v-if="button_type === 'emit'"
          >
            <div class="avatar avatar_sm_md brand_accent_bg pointer">
              <span class="flex-center icon-plus color_text font-24"></span>
            </div>
          </router-link>
        </div>
        <!-- ADD NEW ITEM -->
      </div>
    </div>

    <!-- MODAL COMPONENT -->
    <SwitchClassModal
      v-if="switch_class"
      @closeTriggered="toggleSwitchClass"
      @remountMembersCard="remountComponent"
    ></SwitchClassModal>

    <ResponseDialog
      v-if="response_dialog"
      :alert_msg="alert_card_msg"
      :alert_type="alert_card_type"
      @closeAlert="toggleResponseDialog"
    ></ResponseDialog>
    <!-- MODAL COMPONENT -->
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "MembersCard",

  components: {
    SwitchClassModal: () =>
      import(
        /* webpackChunkName: "SwitchClassModal" */ "@/components/modalComps/classModals/SwitchClassModal"
      ),
    ResponseDialog: () =>
      import(
        /* webpackChunkName: "ResponseDialog" */ "@/components/globalComps/ResponseDialog"
      ),
  },

  computed: {
    ...mapGetters(["classList", "getCurrentClass", "getTour", "startTour"]),
  },

  props: {
    show_add_button: {
      type: Boolean,
      default: false,
    },
    button_type: {
      type: String,
      default: "emit",
    },
    button_function: String,
    button_route: String,
  },

  data() {
    return {
      switch_class: false,
      class_name: "No class",
      class_code: "No class code",

      alert_card_msg: "",
      alert_card_type: "",
      response_dialog: false,
    };
  },

  created() {
    this.setCurrentClass(this.$route.params.id);
  },

  mounted() {
    this.getCurrentClassId();
  },

  methods: {
    ...mapActions(["getSchoolClasses", "setCurrentClass", "getSingleClass"]),

    toggleSwitchClass() {
      this.switch_class = !this.switch_class;
    },

    toggleResponseDialog() {
      this.response_dialog = !this.response_dialog;
    },

    copyClassCode() {
      let code_input = this.$refs.classCode;
      code_input.select();
      code_input.setSelectionRange(0, 99999); /*For mobile devices*/

      document.execCommand("copy");

      this.alert_card_msg = "Class code copied successfully";
      this.alert_card_type = "success";
      this.toggleResponseDialog();
    },

    remountComponent() {
      this.switch_class = !this.switch_class;
      this.getCurrentClassId();
      this.$emit("updateTeacher");
    },

    getCurrentClassId() {
      if (this.getCurrentClass) {
        this.$store.commit("SET_CLASS_ID", this.getCurrentClass);
        this.$emit("classLoaded", this.getCurrentClass);
        this.getSelectedSchoolClass(this.getCurrentClass);
      } else {
        if (this.classList.length > 0) {
          this.getFirstSchoolClass(this.classList);
        } else {
          this.fetchSchoolClasses();
        }
      }
    },

    fetchSchoolClasses() {
      this.getSchoolClasses()
        .then((response) => {
          response.code !== 200 ? this.fetchSchoolClasses() : "";
          this.getFirstSchoolClass(response.data);
        })
        .catch((err) => console.log(err));
    },

    getFirstSchoolClass(class_data) {
      let first_class_data = class_data[0].classes[0];
      this.setCurrentClass(first_class_data.id);
      this.class_name = first_class_data.class_name;
      this.class_code = first_class_data.class_code;
    },

    getSelectedSchoolClass(class_id) {
      this.getSingleClass(class_id)
        .then((response) => {
          if (response.code === 200) {
            this.class_name = response.data.class_name;
            this.class_code = response.data.class_code;
          }
        })
        .catch((err) => console.log(err));
    },
  },
};
</script>

<style lang="scss">
.members-card {
  padding: 15px 15px 25px;

  @include breakpoint_max(lg) {
    width: 123% !important;
  }

  @include breakpoint_max(md) {
    min-height: 80px !important;
    height: 80px;
    width: 100% !important;
    margin-bottom: 14px;
  }

  @include breakpoint_max(sm) {
    min-height: 60px !important;
    padding: 15px;
  }

  .members-card-label {
    left: 0;
    top: 0;
    height: 6px;

    @include breakpoint_max(xs) {
      height: 4.5px;
    }
  }
}

// MEMBER TOP
.member-top {
  .avatar {
    position: relative;
    margin-right: 15px;

    @include breakpoint_max(lg) {
      margin-right: 5px;
    }

    @include breakpoint_max(md) {
      margin-right: 15px;
    }

    @include breakpoint_max(sm) {
      @include equal_min_edge(32);
    }

    @include breakpoint_max(xs) {
      @include equal_min_edge(30);
    }

    span {
      @include transform-center;
      font-size: 20px;

      @include breakpoint_max(xs) {
        font-size: 18px;
      }
    }
  }

  .title {
    font-size: 16px;
    line-height: 22px;
    margin-bottom: 2.5px;

    @include breakpoint_max(lg) {
      font-size: 14px;
    }

    @include breakpoint_max(md) {
      font-size: 16px;
    }

    @include breakpoint_max(sm) {
      font-size: 13px;
      line-height: 20px;
    }
  }

  .text {
    font-size: 12px;
    line-height: 16px;

    @include breakpoint_max(lg) {
      font-size: 11px;
    }

    @include breakpoint_max(md) {
      font-size: 13px;
    }

    @include breakpoint_max(sm) {
      font-size: 12px;
    }
  }

  .caret-icon {
    position: relative;
    top: -7px;

    @include breakpoint_max(lg) {
      top: -8px;
      font-size: 11px !important;
    }

    @include breakpoint_max(md) {
      font-size: 13px !important;
    }

    @include breakpoint_max(sm) {
      font-size: 11px !important;
    }

    @include breakpoint_max(sm) {
      font-size: 10px !important;
    }
  }
}

// MEMBER BOTTOM
.member-bottom {
  margin-top: 30px;

  .text {
    margin-bottom: 15px;
  }

  .code-info {
    margin-bottom: 11px;
  }

  .class-code {
    font-size: 12px;
    line-height: 16px;
    text-overflow: ellipsis;
    border-radius: 3px;
    padding: 11px 12px;

    @include breakpoint_max(lg) {
      display: block;
      font-size: 11.5px;
    }

    .code {
      margin-left: 10px;
      font-size: 14px;

      @include breakpoint_max(lg) {
        font-size: 13px;
      }
    }

    .copy-code {
      position: absolute;
      top: 0;
      left: 0;
      opacity: 0;
      height: 100%;
      width: 100%;
      transition: opacity 0.3s linear 0.1s;
    }
    &:hover {
      .copy-code {
        opacity: 1;
      }
    }
  }

  // ADD NEW
  .add-new {
    @include flex_row_end_nowrap;
    margin-top: 20px;
    margin-left: auto;
    width: 100%;

    .avatar {
      transition: all 0.3s ease-in-out;

      span {
        transition: all 0.3s ease-in-out;
      }

      &:hover {
        background: $brand_primary !important;

        span {
          color: #ffffff !important;
        }
      }
    }
  }
}
</style>
